module.exports = __webpack_public_path__ + "static/media/schulman.907d641f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/schulman.jpg
// module id = 846
// module chunks = 0